import React from 'react';
import { Plus, Copy } from '@phosphor-icons/react';
interface EmptyAnuntSlotProps {
  hasHistory: boolean;
  onCreateNew: () => void;
  onDuplicateLast?: () => void;
}
export function EmptyAnuntSlot({
  hasHistory,
  onCreateNew,
  onDuplicateLast
}: EmptyAnuntSlotProps) {
  return <div className="rounded-2xl border border-dashed border-dark-4 bg-dark-2/50 p-8 sm:p-10 text-center" data-id="element-213">
      <button type="button" onClick={onCreateNew} aria-label="Creează anunț nou" className="group w-16 h-16 rounded-2xl bg-lime-5 hover:bg-lime-4 border border-lime-4 hover:border-lime-3 flex items-center justify-center mx-auto mb-5 transition-colors cursor-pointer" data-id="element-214">
        <Plus size={28} weight="bold" className="text-lime-1 group-hover:scale-110 transition-transform" data-id="element-215" />
      </button>
      <h2 className="text-lg font-semibold text-light-1 mb-2" data-id="element-216">
        {hasHistory ? 'Nu ai un anunț activ' : 'Nu ai un anunț activ încă'}
      </h2>
      <p className="text-sm text-light-3 leading-relaxed max-w-md mx-auto mb-5" data-id="element-217">
        {hasHistory ? 'Pornește o căutare nouă apăsând pe + de mai sus.' : 'Publică un anunț ca proprietarii să-ți poată trimite oferte direct în Izio.'}
      </p>
      {hasHistory && onDuplicateLast && <button type="button" onClick={onDuplicateLast} className="inline-flex items-center justify-center gap-1.5 text-xs text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-218">
          <Copy size={14} weight="regular" data-id="element-219" />
          sau duplichează ultimul anunț
        </button>}
    </div>;
}